export interface NameDiffPart {
    text: string;
    changed: boolean;
}

/**
 * Сравнява две имена по думи (LCS) и маркира думите, които липсват в другото име.
 * По думи, а не по символи — при фирмени имена разликата по символи е шумна и трудна за четене.
 */
export function diffNames(entered: string, official: string): { entered: NameDiffPart[]; official: NameDiffPart[] } {
    const a = words(entered);
    const b = words(official);
    const lcs: number[][] = Array.from({ length: a.length + 1 }, () => new Array(b.length + 1).fill(0));
    for (let i = a.length - 1; i >= 0; i--) {
        for (let j = b.length - 1; j >= 0; j--) {
            lcs[i][j] = a[i] === b[j] ? lcs[i + 1][j + 1] + 1 : Math.max(lcs[i + 1][j], lcs[i][j + 1]);
        }
    }

    const enteredParts: NameDiffPart[] = [];
    const officialParts: NameDiffPart[] = [];
    let i = 0;
    let j = 0;
    while (i < a.length && j < b.length) {
        if (a[i] === b[j]) {
            enteredParts.push({ text: a[i++], changed: false });
            officialParts.push({ text: b[j++], changed: false });
        } else if (lcs[i + 1][j] >= lcs[i][j + 1]) {
            enteredParts.push({ text: a[i++], changed: true });
        } else {
            officialParts.push({ text: b[j++], changed: true });
        }
    }
    while (i < a.length) enteredParts.push({ text: a[i++], changed: true });
    while (j < b.length) officialParts.push({ text: b[j++], changed: true });
    return { entered: enteredParts, official: officialParts };
}

function words(value: string): string[] {
    return (value ?? '').trim().split(/\s+/).filter(Boolean);
}
